import { State, Selector, StateContext, Action, Store } from '@ngxs/store';
import { SetSelectedOrderId,SetInprogressOrderIds, SetSelectedOrderNumber } from '../actions';
import { Injectable } from '@angular/core';
import { patch } from '@ngxs/store/operators';
export class SelectedOrder {
  selectedOrderIdToView: string;
  selectedOrderNumber: string;
  inProgressOrderIds:any;
}

@State<SelectedOrder>({
  name: 'selectedOrderIdToView',
  defaults: {
    selectedOrderIdToView:null,
    selectedOrderNumber: "",
    inProgressOrderIds:[]
  },
})
@Injectable()
export class SelectedOrderState {
  constructor() {}

  @Selector()
  static getSelectedOrderId(state: SelectedOrder){
      return state.selectedOrderIdToView;
  }

  @Action(SetSelectedOrderId)
  SetSelectedOrderId({ setState }: StateContext<SelectedOrder>,  payload : SetSelectedOrderId) {
      setState(
        patch({
          selectedOrderIdToView:payload.payload
        })
        );
  }

  @Selector()
  static getSelectedOrderNumber(state: SelectedOrder){
      return state.selectedOrderNumber;
  }

  @Action(SetSelectedOrderNumber)
  SetSelectedOrderNumber({ setState }: StateContext<SelectedOrder>,  payload : SetSelectedOrderNumber) {
      setState(
        patch({
          selectedOrderNumber:payload.payload
        })
        );
  }


  
  @Selector()
  static getInprogressOrderIds(state: SelectedOrder){
      return state.inProgressOrderIds;
  }

  @Action(SetInprogressOrderIds)
  setInprogressOrderIds({ setState }: StateContext<SelectedOrder>,  payload : SetInprogressOrderIds) {
      setState(
        patch({
          inProgressOrderIds:payload.payload
        })
    );
  }
  
}
